module.exports = __webpack_public_path__ + "media/images/common/shop_reserve/complete-0f5774d33ed9c78ca132df11065572b5.png";